import { BigNumber, ethers } from "ethers";
import { useEffect, useState } from "react";

import { useWeb3React } from "@web3-react/core";

import * as SaleConstants from "../constants/sale";
import { useGnarlyGoatsContracts } from "./useGnarlyGoatsContracts";

export function useSale() {
	const { library, account, chainId } = useWeb3React()
	const { contract, mintPassContract } = useGnarlyGoatsContracts()

	const [saleIsActive, setSaleIsActive] = useState<boolean>(false)

	const [presaleIsActive, setPresaleIsActive] = useState<boolean>(false)

	const [mintPassSaleIsActive, setMintPassSaleIsActive] =
		useState<boolean>(false)

	// Primary Sale Supply
	const [remainingSupply, setRemainingSupply] = useState<number>(5366)

	// Mint Pass Sale Supply
	const [remainingMintPassSupply, setRemainingMintPassSupply] =
		useState<number>(500)

	/**
	 * Set Gnarly Goats Contract Sale State
	 */
	useEffect(() => {
		const initContractState = async () => {
			try {
				setSaleIsActive(await contract?.saleIsActive())

				const _totalSupply = await contract?.totalSupply()
				const _remainingSupply = BigNumber.from(5366).sub(_totalSupply)
				setRemainingSupply(_remainingSupply.toNumber())
			} catch (err) {}
		}
		initContractState()
	}, [library, account, chainId, contract])

	/**
	 * Set Mint Pass Contract Sale State
	 */
	useEffect(() => {
		const initMintPassContractState = async () => {
			try {
				setMintPassSaleIsActive(await mintPassContract?.saleIsActive())

				const _totalSupply = await mintPassContract?.totalSupply()
				const _remainingSupply = BigNumber.from(250).sub(_totalSupply)
				setRemainingMintPassSupply(_remainingSupply.toNumber())
			} catch (err) {}
		}
		initMintPassContractState()
	}, [library, account, chainId, mintPassContract])

	return {
		saleIsActive,
		setSaleIsActive,
		mintPassSaleIsActive,
		setMintPassSaleIsActive,
		presaleIsActive,
		setPresaleIsActive,
		remainingSupply,
		remainingMintPassSupply,
	}
}
